import { Component, Input, Output, EventEmitter, OnInit, HostListener } from '@angular/core';
import { PlaybookEntry } from 'src/app/data/playbook-catalog';

export interface PlaybookSubmission {
  playbook: PlaybookEntry;
  resolvedPrompt: string;
  fieldValues: Record<string, string>;
}

@Component({
  selector: 'app-prompt-popover',
  templateUrl: './prompt-popover.component.html',
  styleUrl: './prompt-popover.component.scss'
})
export class PromptPopoverComponent implements OnInit {
  @Input() showPromptPopover: boolean = false;
  @Input() availablePlaybooks: PlaybookEntry[] = [];
  @Input() selectedPromptIndex: number = 0;
  @Input() agent: string = '';
  @Input() embedded: boolean = false;
  
  @Output() playbookSelected = new EventEmitter<PlaybookEntry>();
  @Output() popoverClosed = new EventEmitter<void>();
  @Output() selectedIndexChanged = new EventEmitter<number>();

  private _selectedIndex: number = 0;

  ngOnInit(): void {
    this._selectedIndex = this.selectedPromptIndex;
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (!this.showPromptPopover) return;
    if (this.availablePlaybooks.length === 0) return;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        event.stopPropagation();
        this._selectedIndex = Math.min(this._selectedIndex + 1, this.availablePlaybooks.length - 1);
        this.selectedIndexChanged.emit(this._selectedIndex);
        this.scrollSelectedIntoView();
        break;
      case 'ArrowUp':
        event.preventDefault();
        event.stopPropagation();
        this._selectedIndex = Math.max(this._selectedIndex - 1, 0);
        this.selectedIndexChanged.emit(this._selectedIndex);
        this.scrollSelectedIntoView();
        break;
      case 'Enter':
        if (this.availablePlaybooks[this._selectedIndex]) {
          event.preventDefault();
          event.stopPropagation();
          this.playbookSelected.emit(this.availablePlaybooks[this._selectedIndex]);
        }
        break;
      case 'Escape':
        event.preventDefault();
        event.stopPropagation();
        this.popoverClosed.emit();
        break;
    }
  }

  get currentSelectedIndex(): number {
    return this._selectedIndex;
  }

  selectPlaybook(playbook: PlaybookEntry): void {
    this.playbookSelected.emit(playbook);
  }

  onStopPropagation(event: Event): void {
    event.stopPropagation();
  }

  private scrollSelectedIntoView(): void {
    setTimeout(() => {
      const selectedElement = document.querySelector('.prompt-item.selected');
      if (selectedElement) {
        selectedElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 0);
  }
}
